<div class="slider-container">
  <div class="label-container">
    <label for="slider">Einmalige Zuzahlung: </label>
    <span id="sliderValue" #sliderValue>
      {{ currentValue()?.additionalPaymentAmount | currency: 'EUR' : 'code' : '1.2-2' }}</span
    >
  </div>
  <div class="slider-input-container">
    <div class="markers">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <input
      (change)="updateValue()"
      (mousemove)="updateValue()"
      (touchmove)="updateValue()"
      type="range"
      min="1"
      [attr.aria-valuemin]="steps[0]"
      max="4"
      [attr.aria-valuemax]="steps[3]"
      value="1"
      class="slider"
      id="slider"
      step="1"
      list="markings"
      [attr.aria-valuenow]="currentValue()?.additionalPaymentAmount"
      [attr.aria-valuetext]="currentValue()?.additionalPaymentAmount | currency: 'EUR' : 'code' : '1.2-2'"
      [disabled]="isDisabled()"
      #slider
    />
    <datalist id="markings">
      <option value="1"></option>
      <option value="2"></option>
      <option value="3"></option>
      <option value="4"></option>
    </datalist>
  </div>
</div>
